import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, ButtonToolbar, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  formLabelsTheme,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ModalClient } from "../filterModal/ModalClient";
import {
  editPreferences,
  fetchIdPreferences,
  selectIdPreferences,
  selectLoading,
} from "./motorPoolSlice";
import { ModalInspection } from "../filterModal/ModalInspection";
import { ModalInspectionCreate } from "./ModalInspectionCreate";
import { v4 as uuidv4 } from "uuid";
import { ModalLocationSelect } from "./ModalLocationSelect";
import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";

function RedditTextField(props) {
  const classes = useStylesReddit();
  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
export const PreferencesEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdPreferences);
  const dataOffice = useSelector(selectOffice);
  const paginationSet = useSelector(selectPagination);
  const { id } = useParams();

  const [listClient, setListClient] = useState([]);
  const [listInspectionPoint, setListInspectionPoint] = useState([]);
  const [listInspectionPointEnable, setListInspectionPointEnable] = useState(
    []
  );
  const [listInspectionPointDisable, setListInspectionPointDisable] = useState(
    []
  );
  const [dataRow, setDataRow] = useState(null);
  const [listDamage, setListDamage] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [formatExtraData, setFormatExtraData] = useState([]);
  const [getData, setGetData] = useState(false);

  // initial

  const [formValues, setFormValues] = useState({
    preferences_name: {
      value: "",
      error: false,
      required: "Y",
    },
    preferences_description: {
      value: "",
      error: false,
      required: "N",
    },
    office_id: {
      value: "ae0c1132-64de-4ec3-ba0c-ef483ae3f402",
      error: false,
      required: "Y",
    },
    def_loc_inbound_receiving: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_inbound_receiving_name: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_inbound_staging: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_inbound_staging_name: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_outbound_shipping: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_outbound_shipping_name: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_outbound_staging: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_outbound_staging_name: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_service_area: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_service_area_name: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_damage_area: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_damage_area_name: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_block_area: {
      value: "",
      error: false,
      required: "Y",
    },
    def_loc_block_area_name: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  // initial

  const [formInspaction, setFormInspaction] = useState({
    inspectioncategory_id: {
      value: "",
      error: false,
      required: "Y",
    },
    inspectioncategory_name: {
      value: "",
      error: false,
      required: "Y",
    },
    point_inspection: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [formDamage, setFormDamage] = useState({
    damagecondition_id: {
      value: "",
      error: false,
      required: "Y",
    },
    damagecondition_name: {
      value: "",
      error: false,
      required: "Y",
    },
    max_weight: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(fetchIdPreferences(id));

      await dispatch(
        fetchOffice({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        preferences_name: {
          value: dataId.preferences_name,
          error: false,
          required: "Y",
        },
        preferences_description: {
          value: dataId.preferences_description,

          error: false,
          required: "N",
        },
        office_id: {
          value: dataId.office_id,
          error: false,
          required: "Y",
        },
        def_loc_inbound_receiving: {
          value: dataId.def_loc_inbound_receiving,
          error: false,
          required: "Y",
        },
        def_loc_inbound_receiving_name: {
          value: dataId.def_loc_inbound_receiving_name,
          error: false,
          required: "Y",
        },
        def_loc_inbound_staging: {
          value: dataId.def_loc_inbound_staging,
          error: false,
          required: "Y",
        },
        def_loc_inbound_staging_name: {
          value: dataId.def_loc_inbound_staging_name,
          error: false,
          required: "Y",
        },
        def_loc_outbound_shipping: {
          value: dataId.def_loc_outbound_shipping,
          error: false,
          required: "Y",
        },
        def_loc_outbound_shipping_name: {
          value: dataId.def_loc_outbound_shipping_name,
          error: false,
          required: "Y",
        },
        def_loc_outbound_staging: {
          value: dataId.def_loc_outbound_staging,
          error: false,
          required: "Y",
        },
        def_loc_outbound_staging_name: {
          value: dataId.def_loc_outbound_staging_name,
          error: false,
          required: "Y",
        },
        def_loc_service_area: {
          value: dataId.def_loc_service_area,
          error: false,
          required: "Y",
        },
        def_loc_service_area_name: {
          value: dataId.def_loc_service_area_name,
          error: false,
          required: "Y",
        },
        def_loc_damage_area: {
          value: dataId.def_loc_damage_area,
          error: false,
          required: "Y",
        },
        def_loc_damage_area_name: {
          value: dataId.def_loc_damage_area_name,
          error: false,
          required: "Y",
        },
        def_loc_block_area: {
          value: dataId.def_loc_block_area,
          error: false,
          required: "Y",
        },
        def_loc_block_area_name: {
          value: dataId.def_loc_block_area_name,
          error: false,
          required: "Y",
        },
      });
      setListClient(dataId.clients === null ? [] : dataId.clients);

      const dataEnable =
        dataId.inspectpoints === null
          ? []
          : dataId.inspectpoints.filter((item) => item.is_enable === "Y");
      const listEnable = dataEnable.map((item) => {
        return {
          ...item,
          id: uuidv4(),
        };
      });

      const dataDisable =
        dataId.inspectpoints === null
          ? []
          : dataId.inspectpoints.filter((item) => item.is_enable === "N");
      const listDisable = dataDisable.map((item) => {
        return {
          ...item,
          id: uuidv4(),
        };
      });

      setListInspectionPointEnable(listEnable);
      setListInspectionPointDisable(listDisable);
    }
  }, [dataId]);

  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const initEnable = listInspectionPointEnable.map((item) => {
      return {
        ...item,
        is_enable: "Y",
      };
    });

    const initDisable = listInspectionPointDisable.map((item) => {
      return {
        ...item,
        is_enable: "N",
      };
    });

    const params = {
      preferences_id: id,
      preferences_name: formValues.preferences_name.value,
      preferences_description: formValues.preferences_description.value,
      office_id: formValues.office_id.value,
      def_loc_inbound_receiving: formValues.def_loc_inbound_receiving.value,
      def_loc_inbound_staging: formValues.def_loc_inbound_staging.value,
      def_loc_outbound_shipping: formValues.def_loc_outbound_shipping.value,
      def_loc_outbound_staging: formValues.def_loc_outbound_staging.value,
      def_loc_service_area: formValues.def_loc_service_area.value,
      def_loc_damage_area: formValues.def_loc_damage_area.value,
      def_loc_block_area: formValues.def_loc_block_area.value,
      inspectpoints: initEnable.concat(initDisable),
      clients: listClient,
    };
    try {
      const response = await dispatch(editPreferences(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdPreferences(id));
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const actionFormatterClient = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) =>
              handleDeleteClient(e, row, rowIndex, formatExtraData)
            }
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsClient = [
    {
      text: "Client Code",
      dataField: "client_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Client Name",
      dataField: "client_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "City",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterClient,
      align: "center",
      headerAlign: "center",
      formatExtraData: listClient,
    },
  ];

  const handleDisabled = async (e, row, rowIndex) => {
    const objToMove = listInspectionPointEnable.find(
      (obj) => obj.id === row.id
    );
    console.log(objToMove, "objToMove");

    if (objToMove) {
      // Pindahkan objek ke array test2
      setListInspectionPointDisable((prevTest2) => [...prevTest2, objToMove]);

      // Hapus objek dari array test
      const filteredTest = listInspectionPointEnable.filter(
        (obj) => obj.id !== row.id
      );
      setListInspectionPointEnable(filteredTest);
    }
  };

  const handleEnable = async (e, row, rowIndex) => {
    const objToMove = listInspectionPointDisable.find(
      (obj) => obj.id === row.id
    );
    if (objToMove) {
      // Pindahkan objek ke array test2
      setListInspectionPointEnable((prevTest2) => [...prevTest2, objToMove]);
      // Hapus objek dari array test
      const filteredTest = listInspectionPointDisable.filter(
        (obj) => obj.id !== row.id
      );
      setListInspectionPointDisable(filteredTest);
    }
  };

  const handleDeleteInspections = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.id !== idColumn);
    setListInspectionPointEnable(items);
  };

  const actionFormatterInspections = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
            onClick={(e) => {
              setDataRow(row);
              setRowIndex(rowIndex);
              setFormatExtraData(formatExtraData);
              setShowInspection(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
            </span>
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
            onClick={(e) =>
              handleDeleteInspections(e, row, rowIndex, formatExtraData)
            }
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Disabled</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
            onClick={() => handleDisabled(e, row, rowIndex)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/eye-slash.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const actionFormatterInspectionsDisable = (
    e,
    row,
    rowIndex,
    formatExtraData
  ) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Enabled</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
            onClick={() => handleEnable(e, row, rowIndex)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/eye.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsInspection = [
    {
      text: "Inspection Point",
      dataField: "point_inspection",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Inpection Category",
      dataField: "inspectioncategory_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterInspections,
      align: "center",
      headerAlign: "center",
      formatExtraData: listInspectionPointEnable,
    },
  ];

  const columnsInspectionDisable = [
    {
      text: "Inspection Point",
      dataField: "point_inspection",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Inpection Category",
      dataField: "inspectioncategory_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterInspectionsDisable,
      align: "center",
      headerAlign: "center",
      formatExtraData: listInspectionPoint,
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleChangeOffice = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["office_id"]: {
        ...formValues["office_id"],
        value,
      },
    });
  };

  const officeOptions = dataOffice.map((e) => {
    return {
      value: e.office_id,
      label: e.office_name,
    };
  });

  const index = officeOptions.findIndex(
    (obj) => obj.value === formValues.office_id.value
  );

  // modal Client

  const [showClient, setShowClient] = useState(false);

  const handleCloseClient = () => setShowClient(false);
  const handleShowClient = () => setShowClient(true);
  const handleDeleteClient = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.client_id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.client_id !== idColumn);
    setListClient(items);
  };

  // modal Inspection

  const [showInspection, setShowInspection] = useState(false);

  const handleCloseInspection = () => setShowInspection(false);
  const handleShowInspection = () => setShowInspection(true);
  const handleDeleteInspection = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.pref_inspectionpoint_id;
    const temp = [...formatExtraData];
    let items = temp.filter(
      (value, index) => value.pref_inspectionpoint_id !== idColumn
    );
    setListInspectionPoint(items);
  };

  // modal Inspection Modal

  const [showInspectionModal, setShowInspectionModal] = useState(false);
  const [showDamageModal, setShowDamageModal] = useState(false);

  const [fields, setFields] = useState([
    { id: "", value: "", params: "", label: "", add: "N", editor: "text" },
  ]);

  const [value, setValue] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);

    const status = newValue === 0 ? "Y" : "\u0000";

    const filteredData = listInspectionPoint.filter(
      (item) => item.is_enable === status
    );

    console.log(filteredData, "filteredData");
    console.log(status, "status");
    // forceUpdate();
    // setForce(true);
  };

  // Modal Inbount
  const [showLocation, setShowLocation] = useState(false);
  const [typeLocation, setTypeLocation] = useState(null);
  const [location, setLocation] = useState(null);

  const [fieldsLocation, setFieldsLocation] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              Edit Preferences
            </CardHeaderTitle>

            <CardHeaderToolbar>
              <Button
                className="primary"
                onClick={() =>
                  history.push(`/administration/motor-pool/preferences`)
                }
              >
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              <>
                {/* label */}
                <div>
                  <Row>
                    <Col xs={12} sm={3} md={6} lg={6}>
                      <RedditTextField
                        required
                        label="Name"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="preferences_name"
                        value={formValues.preferences_name.value}
                        onChange={handleChange}
                        error={formValues.preferences_name.error}
                        helperText={
                          formValues.preferences_name.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                      <Autocomplete
                        disablePortal
                        name="office_id"
                        options={officeOptions}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        value={
                          officeOptions.find(
                            (option) =>
                              option.value === formValues.office_id.value
                          ) || null
                        }
                        disableClearable={true}
                        onChange={handleChangeOffice}
                        // value={officeOptions[index]}
                        renderInput={(params) => (
                          <RedditTextField
                            className={classes.margin}
                            {...params}
                            required
                            label="Office "
                            id="reddit-input"
                            size="small"
                            fullWidth
                            placeholder="Select Area"
                            name="office_id"
                            helperText={
                              formValues.office_id.error ? (
                                <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                  {iconError} {"This field is required"}
                                </FormHelperText>
                              ) : (
                                ""
                              )
                            }
                          />
                        )}
                      />
                    </Col>
                    <Col xs={12} sm={3} md={6} lg={6}>
                      <RedditTextField
                        label="Description"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="preferences_description"
                        value={formValues.preferences_description.value}
                        onChange={handleChange}
                        multiline
                        rows="4"
                      />
                    </Col>
                  </Row>
                </div>
                <hr />
                {/* Default Location */}

                <div>
                  <h5 className="font-weight-boldest">Default Location</h5>
                  {/* inbound */}
                  <div>
                    <p className="font-weight-boldest mb-2 mt-3">Inbound</p>

                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={8} lg={8}>
                            <RedditTextField
                              label="Default Receiving Area"
                              // className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={
                                formValues.def_loc_inbound_receiving_name.value
                              }
                              readOnly
                            />
                          </Col>
                          <Col>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-2">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setGetData(true);
                                    setTypeLocation("RECEIVING_AREA");
                                    setLocation("Inbound");
                                    setShowLocation(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={8} lg={8}>
                            <RedditTextField
                              label="Default Staging Area"
                              // className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={
                                formValues.def_loc_inbound_staging_name.value
                              }
                              readOnly
                            />
                          </Col>
                          <Col>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-2">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setGetData(true);

                                    setTypeLocation("STAGING_AREA");
                                    setLocation("Inbound");
                                    setShowLocation(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  {/* Outbound */}
                  <div>
                    <p className="font-weight-boldest mb-2 mt-3">Outbound</p>

                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={8} lg={8}>
                            <RedditTextField
                              label="Default Shipping Area"
                              // className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={
                                formValues.def_loc_outbound_shipping_name.value
                              }
                              readOnly
                            />
                          </Col>
                          <Col>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-2">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setGetData(true);

                                    setTypeLocation("SHIPPING_AREA");
                                    setLocation("Outbound");
                                    setShowLocation(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={8} lg={8}>
                            <RedditTextField
                              label="Default Staging Area"
                              // className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={
                                formValues.def_loc_outbound_staging_name.value
                              }
                              readOnly
                            />
                          </Col>
                          <Col>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-2">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setGetData(true);

                                    setTypeLocation("STAGING_AREA");
                                    setLocation("Outbound");
                                    setShowLocation(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  {/* Internal Process */}
                  <div>
                    <p className="font-weight-boldest mb-2 mt-3">
                      Internal Process
                    </p>

                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={8} lg={8}>
                            <RedditTextField
                              label="Default Service Area"
                              // className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.def_loc_service_area_name.value}
                              readOnly
                            />
                          </Col>
                          <Col>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-2">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setGetData(true);

                                    setTypeLocation("SERVICE_AREA");
                                    setLocation("Internal Process");
                                    setShowLocation(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col xs={10} sm={3} md={8} lg={8}>
                            <RedditTextField
                              label="Default Blocked Area"
                              // className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.def_loc_block_area_name.value}
                              readOnly
                            />
                          </Col>
                          <Col>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-2">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setGetData(true);

                                    setTypeLocation("MAINTENANCE_AREA");
                                    setLocation("Internal Process Block");
                                    setShowLocation(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={8} lg={8}>
                            <RedditTextField
                              label="Default Damage Area"
                              // className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.def_loc_damage_area_name.value}
                              readOnly
                            />
                          </Col>
                          <Col>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-2">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setGetData(true);

                                    setTypeLocation("MAINTENANCE_AREA");
                                    setLocation("Internal Process Damage");
                                    setShowLocation(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
                <hr />
                {/* Inspection Point Configurations */}
                <div>
                  <h5 className="font-weight-boldest mb-5">
                    Inspection Point Configurations
                  </h5>

                  <>
                    <Tabs
                      value={value}
                      onChange={handleChangeTab}
                      indicatorColor="primary"
                      textColor="primary"
                    >
                      <Tab label="Enabled" />
                      <Tab label="Disabled" />
                    </Tabs>
                    {value === 0 && (
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                        bootstrap4
                        
                        keyField="id"
                        data={listInspectionPointEnable}
                        columns={columnsInspection}
                        hover
                        striped
                        headerClasses="header-class"
                      />
                    )}
                    {value === 1 && (
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                        bootstrap4
                        
                        keyField="id"
                        data={listInspectionPointDisable}
                        columns={columnsInspectionDisable}
                        hover
                        striped
                        headerClasses="header-class"
                      />
                    )}
                  </>

                  <Row className="mt-6 justify-content-end">
                    <Button
                      variant="outline-primary"
                      onClick={handleShowInspection}
                    >
                      Configure Inspection Point
                    </Button>
                  </Row>
                </div>
                <hr />

                {/* Client */}
                <div>
                  <h5 className="text-bold">Clients</h5>

                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                    bootstrap4
                    
                    keyField="client_id"
                    data={listClient}
                    columns={columnsClient}
                    hover
                    striped
                    headerClasses="header-class"
                  />

                  <Row className="mt-6 justify-content-end">
                    <Button
                      variant="outline-primary"
                      onClick={handleShowClient}
                    >
                      Add Client
                    </Button>
                  </Row>
                </div>
                <hr />

                {/* handleSave */}
                <Row className="mt-6 justify-content-end">
                  <Button variant="primary" onClick={handleSave}>
                    Save
                  </Button>
                </Row>
              </>
            </ThemeProvider>
          </CardBody>
        </Card>
      )}

      <ModalClient
        isOpen={showClient}
        handleClose={handleCloseClient}
        handleShow={handleShowClient}
        setListClient={setListClient}
        listClient={listClient}
      />

      <ModalInspectionCreate
        isOpen={showInspection}
        handleClose={handleCloseInspection}
        handleShow={handleShowInspection}
        setShow={setShowInspection}
        showInspectionModal={showInspectionModal}
        setShowInspectionModal={setShowInspectionModal}
        setFields={setFields}
        fields={fields}
        setShowDamageModal={setShowDamageModal}
        showDamageModal={showDamageModal}
        formValues={formInspaction}
        setFormValues={setFormInspaction}
        formDamage={formDamage}
        setFormDamage={setFormDamage}
        listInspectionPoint={listInspectionPointEnable}
        setListInspectionPoint={setListInspectionPointEnable}
        dataRow={dataRow}
        setDataRow={setDataRow}
        listDamage={listDamage}
        setListDamage={setListDamage}
        setFormatExtraData={setFormatExtraData}
        formatExtraData={formatExtraData}
        rowIndex={rowIndex}
        setRowIndex={setRowIndex}
      />

      <ModalLocationSelect
        isOpen={showLocation}
        setShow={setShowLocation}
        setTypeLocation={setTypeLocation}
        typeLocation={typeLocation}
        location={location}
        setLocation={setLocation}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsLocation}
        fields={fieldsLocation}
        getData={getData}
        setGetData={setGetData}
      />
    </>
  );
};
